import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

const baseUrl = process.env.PUBLIC_URL;
const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

const render = () => {
  root.render(
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>);
    
}

render();